// src/KantTreeDark.js (یا نام کامپوننت شما)
import React, { useState, useEffect, useRef } from "react";
import Tree from "react-d3-tree";
import kantData2 from "./kantData2"; // اطمینان از استفاده از داده‌های صحیح

const containerStyles = {
  width: "100vw",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#282c34",
  direction: "ltr", // کانتینر اصلی همچنان ltr برای سادگی محاسبات d3
};

// تنظیمات برای foreignObject در حالت افقی (متن در سمت چپ دایره)
const foreignObjectProps = {
  width: 180, // عرض جعبه متن
  height: 100, // ارتفاع جعبه متن
  x: -200, // (-(width جعبه متن) - (فاصله از دایره) ) -> -(180) - 20 = -200
  y: -50, // برای وسط‌چین کردن عمودی متن نسبت به دایره (نصف height)
};

const renderForeignObjectNodeDark = ({
  nodeDatum,
  toggleNode,
  foreignObjectProps,
}) => (
  <g>
    {/* دایره نود در مرکز (0,0) گروه g قرار می‌گیرد */}
    <circle
      r={12}
      fill={
        nodeDatum.children ? "rgba(76, 175, 80, 0.8)" : "rgba(80, 80, 80, 0.9)"
      }
      stroke="rgba(200, 200, 200, 0.7)"
      strokeWidth="1.5px"
      onClick={toggleNode}
      cursor="pointer"
    />
    {/* foreignObject برای نمایش متن فارسی در سمت چپ دایره */}
    <foreignObject {...foreignObjectProps}>
      <div
        style={{
          width: foreignObjectProps.width, // اطمینان از اعمال عرض
          height: foreignObjectProps.height, // اطمینان از اعمال ارتفاع
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid rgba(150, 150, 150, 0.6)",
          borderRadius: "6px",
          backgroundColor: "rgba(55, 55, 55, 0.95)",
          padding: "8px",
          textAlign: "center",
          direction: "rtl", // متن داخل جعبه راست به چپ
          fontSize: "12px",
          color: "#e0e0e0",
          boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
          overflowWrap: "break-word",
          wordWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        {nodeDatum.name}
      </div>
    </foreignObject>
  </g>
);

export default function KantPhilosophyHorizontalTree() {
  // تغییر نام کامپوننت
  const [translate, setTranslate] = useState({ x: 0, y: 0 });
  const treeWrapperRef = useRef(null);

  useEffect(() => {
    if (treeWrapperRef.current) {
      const dimensions = treeWrapperRef.current.getBoundingClientRect();
      setTranslate({
        x: dimensions.width * 0.85, // شروع از سمت راست صفحه
        y: dimensions.height / 2, // وسط عمودی
      });
    }
  }, []);

  return (
    <div style={containerStyles} ref={treeWrapperRef}>
      {translate.x !== 0 && (
        <Tree
          data={kantData2} // استفاده از داده‌های صحیح
          orientation="horizontal" // تغییر به افقی
          pathFunc="elbow" // یا "diagonal" یا "straight" یا "step"
          collapsible={true}
          initialDepth={1} // عمق اولیه باز بودن
          translate={translate}
          separation={{ siblings: 1.0, nonSiblings: 1.2 }} // تنظیم فاصله
          nodeSize={{ x: 240, y: 120 }} // x: فضای افقی (عمق), y: فضای عمودی (عرض بین هم‌سطح‌ها)
          zoomable={true}
          scaleExtent={{ min: 0.2, max: 1.5 }}
          renderCustomNodeElement={(rd3tProps) =>
            renderForeignObjectNodeDark({ ...rd3tProps, foreignObjectProps })
          }
          depthFactor={-220} // منفی برای رشد از راست به چپ
          centeringTransitionDuration={600}
          styles={{
            links: {
              stroke: "rgba(180, 180, 180, 0.6)",
              strokeWidth: 1.5,
            },
          }}
        />
      )}
    </div>
  );
}
